import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash-es';
import classNames from 'classnames/bind';
import styles from '../../styles.module.scss';
import SportHeroButton from './SportHeroButton';

const cx = classNames.bind(styles);

const SportHero = ({ chosenCity, chosenSport, sportDetails }) => {
  const [hero, setHero] = useState({
    heroCta: {},
    heroImageUrl: '',
    heroText: '',
    heroSubText: '',
  });

  useEffect(() => {
    if (sportDetails?.hero) {
      setHero({
        heroCta: sportDetails.hero?.heroCta || {},
        heroImageUrl: sportDetails.hero?.heroImage?.image?.url || '',
        heroText: sportDetails.hero?.heroText || '',
        heroSubText: sportDetails.hero?.heroSubText || '',
      });
    }
  }, [sportDetails]);

  return (
    <div className={cx('heroContainer')}>
      <div
        className={cx('hero', !hero.heroImageUrl && 'corporate-hero')}
        style={{
          ...(hero.heroImageUrl
            ? {
                backgroundImage: `url("${hero.heroImageUrl}")`,
              }
            : {
                backgroundImage:
                  'url(https://rivall-public.s3-us-west-1.amazonaws.com/home-page/hero-img-1.jpg)',
              }),
        }}
      >
        <div className={cx('jumbotron')}>
          <h1 className={cx('title')}>{hero.heroText || _.capitalize(chosenSport)}</h1>
          {!!hero.heroSubText && (
            <div
              className={cx('subtitle')}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: hero.heroSubText }}
            />
          )}
          <SportHeroButton
            chosenCity={chosenCity}
            chosenSport={chosenSport}
            ctaObject={hero.heroCta}
          />
        </div>
      </div>
    </div>
  );
};

SportHero.propTypes = {
  chosenSport: PropTypes.string.isRequired,
  chosenCity: PropTypes.string.isRequired,
  sportDetails: PropTypes.shape({
    hero: PropTypes.shape({
      heroCta: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
        newTab: PropTypes.bool,
      }),
      heroImage: PropTypes.shape({
        image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      heroSubText: PropTypes.string,
      heroText: PropTypes.string,
    }),
  }),
};

SportHero.defaultProps = {
  sportDetails: PropTypes.shape({}),
};

export default SportHero;
